(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider', 'ROLES'];

    function stateConfig($stateProvider, ROLES) {
        $stateProvider
            .state('concurrent-reviews', {
                parent: 'entity',
                url: '/concurrent-reviews',
                ncyBreadcrumb: {
                    label: 'Concurrent Reviews'
                },
                data: {
                    authorities: [ROLES.ROLE_USER]
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/concurrent-reviews/dashboard/concurrent-reviews.html',
                        controller: 'ConcurrentReviewsController',
                        controllerAs: 'vm'
                    }
                },
            });
    }
})();
